export default {
  visableCount: {
    textAlign: 'center',
    fontSize: '12px',
    mt: '60px'
  }
};